import {Button} from "../../ui/button";

export function Footer() {
    return (
        <footer className="bg-slate-50 border-t border-slate-200">
            <div className="max-w-6xl mx-auto px-6 py-12">
                <div className="grid md:grid-cols-2 gap-12">
                    <div>
                        <h3 className="font-light tracking-wider mb-4 text-slate-900">KONTAKT</h3>
                        <div className="space-y-2 text-slate-600">
                            <div>Sportverein Stanzach Winter</div>
                            <div>Stanzach 123</div>
                            <div>6642 Stanzach</div>
                        </div>
                    </div>
                    <div className="flex justify-end items-start">
                        <Button variant="outline" className="border-slate-300 text-slate-600 hover:text-slate-900 hover:border-slate-900">
                            Impressum
                        </Button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
